var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-a33f27c8": "",
    "data-v-bcc862e6": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 2 40 60",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-a33f27c8": "",
    "data-v-bcc862e6": "",
    d: "M46 2H18a6 6 0 00-6 6v48a6 6 0 006 6h28a6 6 0 006-6V8a6 6 0 00-6-6zm4 54a4 4 0 01-4 4H18a4 4 0 01-4-4V8a4 4 0 014-4h28a4 4 0 014 4zm-18-6a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2zm4-49a1 1 0 01-1 1h-6a1 1 0 110-2h6a1 1 0 011 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0ecacc4d21efd803cfb83e56724e34c6.svg";
export { ForwardRef as ReactComponent };